var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 15.6667C20 15.4167 19.75 15.1667 19.5 15.1667H12.5C12.2083 15.1667 12 15.4167 12 15.6667V16.8333C12 17.125 12.2083 17.3333 12.5 17.3333H19.5C19.75 17.3333 20 17.125 20 16.8333V15.6667ZM19.5 18.6667H12.5C12.2083 18.6667 12 18.9167 12 19.1667V20.3333C12 20.625 12.2083 20.8333 12.5 20.8333H19.5C19.75 20.8333 20 20.625 20 20.3333V19.1667C20 18.9167 19.75 18.6667 19.5 18.6667ZM24 10.8333C24 10.3333 23.75 9.79166 23.375 9.41666L19.9167 5.95833C19.5417 5.58333 19 5.33333 18.5 5.33333H10C8.875 5.33333 8 6.24999 8 7.33333V24.6667C8 25.7917 8.875 26.6667 10 26.6667H22C23.0833 26.6667 24 25.7917 24 24.6667V10.8333ZM18.6667 7.49999L21.8333 10.6667H18.6667V7.49999ZM22 24.6667H10V7.33333H16.6667V11.6667C16.6667 12.25 17.0833 12.6667 17.6667 12.6667H22V24.6667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.3dff6b6dff98715816815478e7cecc2d.svg";
export { ForwardRef as ReactComponent };